import React from "react";
import AntdStatistic from "antd/lib/statistic";
import {withError} from '@fishx/tracker';

const Statistic = (props) => <AntdStatistic {...props} />
Statistic.displayName = 'Statistic';
export default withError(Statistic);




// WEBPACK FOOTER //
// ./src/components/statistic/index.tsx